module.exports = __webpack_public_path__ + "static/img/img_art3_sm.dfa189e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_art3_sm.jpg
// module id = r+iw
// module chunks = 1